import { DeleteOutlined, InboxOutlined } from "@ant-design/icons";
import {
  Alert,
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Row,
  Select,
  Space,
} from "antd";
import Dragger from "antd/es/upload/Dragger";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { category_create, get_all_category } from "../../../services/category";
// import Editor from "../../createNews/components/MenuBar";
import { get_check_task } from "../../../services/task";

import { useAuth } from "../../../utils/Auth/AuthWrapper";
import Editor from "../../../components/Editor";
import EditorContentTestPage from "../../../components/EditorTest";
import { useWatch } from "antd/lib/form/Form";

type Props = {
  params: any;
  setImageUrluse: (value: any) => void;
  form: any;
};

const InformationPage = (props: Props) => {
  const auth = useAuth();
  const { t } = useTranslation();
  const [tagSelect, setTagSelect] = useState<any>([]);
  const [tagOptions, setTagOptions] = useState<any>([]);
  const [taskIds, setTaskIds] = useState<string[]>([]);
  // const [form] = Form.useForm();
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const submission_type = useWatch("img", props.form);

  const handleTimeChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    setValue: (value: string) => void,
  ) => {
    let value = e.target.value;
    value = value.replace(/[^0-9:]/g, "");
    const segments = value.split(":");
    if (segments.length > 3) return;
    if (/^([01]?\d|2[0-3])?(:([0-5]?\d)?)?(:([0-5]?\d)?)?$/.test(value)) {
      setValue(value);
    }
  };

  // create tag
  const handleChangeTag = async (value: any, options: any) => {
    setTagSelect(value);
  };

  const onSelectTag = async (value: any, objTag: any) => {
    try {
      if (Object.keys(objTag).length === 0) {
        const create_tag = await category_create({
          user_id: auth.user.user_id,
          name: value,
        });
        if (create_tag.status == "success") {
          const newId = create_tag.id;
          const newName = create_tag.category;

          setTagOptions((prev: any) => [
            ...prev,
            { label: newName, value: newId },
          ]);

          setTagSelect((prev: any) => {
            const res = prev.map((item: any) => {
              return item === value ? newId : item;
            });
            props.form.setFieldsValue({ tags: res });
            return res;
          });
        } else {
          message.error(create_tag.message);
          setTagOptions((prev: any) => [...prev]);

          setTagSelect((prev: any) => {
            const res = prev
              .map((item: any) => {
                return item === value ? null : item;
              })
              .filter((e: any) => e != null);
            props.form.setFieldsValue({ tags: res });
            return res;
          });
        }
      } else {
      }
    } catch (e) {
      console.error(e);
    }
  };

  // get category
  const getCategory = async () => {
    try {
      const res = await get_all_category();
      const category = res.result;
      const list = category.map((item: any) => ({
        // value: item.name,
        value: item.category_id,
        label: item.name,
      }));
      setTagOptions(list);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const validateCodename = async (_: any, value: string) => {
    if (!value) {
      return; // ✅ ใช้ required ตรวจสอบช่องว่างแทน
    }
    if (
      taskIds.some((taskId) => taskId.toLowerCase() === value.toLowerCase())
    ) {
      return Promise.reject("This code name already exists!");
    }
    return Promise.resolve();
  };

  const getDataAllTask = async () => {
    try {
      if (props.params.action === "create") {
        const data = { fields: ["*"], filter: { status: 1 } };
        const res = await get_check_task(data);
        if (res?.result) {
          const ids = res.result.map((item: any) => item.task_id);
          setTaskIds(ids);
        } else {
          console.warn("No results found in API response");
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getBase64 = (file: File, callback: (imageUrl: string) => void) => {
    const reader = new FileReader();
    reader.onload = () => callback(reader.result as string);
    reader.readAsDataURL(file);
  };

  useEffect(() => {
    getCategory();
    getDataAllTask();
    props.form.validateFields(["task_id"]);
  }, []);

  const getImageUrl = (fileData: any) => {
    const img = fileData.file ? fileData.file : fileData;
    if (!img) return "";

    if (typeof img === "string") {
      console.log("string");
      return process.env.REACT_APP_API + img;
    }

    const rawFile = img.originFileObj || img;

    if (rawFile instanceof File || rawFile instanceof Blob) {
      return URL.createObjectURL(rawFile);
    }

    return "";
  };

  return (
    <div className="add-task-body-layout">
      {/* <Form.Item name="test">
        <EditorContentTestPage />
      </Form.Item> */}
      {/* <Form layout="vertical" onFinish={createEvent} props.form={props.form}> */}
      <Form.Item name="img">
        <Dragger
          name="file"
          multiple={false}
          accept=".png, .jpeg, .jpg"
          style={{ borderRadius: "20px", padding: "20px" }}
          showUploadList={false}
          onChange={async (info: any) => {
            const file = info.file.originFileObj;
            if (file) {
              props.setImageUrluse(file);
              getBase64(file, (imageUrl: string) => {
                setImageUrl(imageUrl);
              });
            } else {
              console.error("File is undefined");
            }
          }}
        >
          {imageUrl ||
          (props.form.getFieldValue("img") &&
            !/^(https:\/\/|www\.)/i.test(props.form.getFieldValue("img"))) ? ( // ตรวจสอบว่าไม่ใช่ URL ภายนอก
            <img
              src={
                imageUrl // ถ้าอัปโหลดใหม่ ให้ใช้ base64
                  ? imageUrl
                  : getImageUrl(props.form.getFieldValue("img"))
                // `${process.env.REACT_APP_API}${props.form.getFieldValue(
                //     "img",
                //   )}`
                // ใช้รูปจาก API
              }
              alt="avatar"
              className="show-image"
            />
          ) : (
            <div>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                {t("Drag your image here, or browse")}
              </p>
              <p className="ant-upload-hint">
                {t("Support Only PNG and JPEG files are allowed")}
              </p>
            </div>
          )}
        </Dragger>
      </Form.Item>
      <Alert
        style={{ marginTop: 20 }}
        showIcon
        message={`${t("The image size should be")} 1024 * 537`}
        type="info"
        closable={false}
      />
      {imageUrl && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            type="default"
            danger
            icon={<DeleteOutlined />}
            style={{
              marginTop: "10px",
              justifyContent: "center",
            }}
            onClick={() => {
              props.form.setFieldsValue({ img: null });
              setImageUrl(null);
            }}
          >
            Delete Image
          </Button>
        </div>
      )}
      <Row gutter={[16, 16]} style={{ marginTop: "2rem" }}>
        <Col xs={24} md={12}>
          <Form.Item
            name="name"
            label={t("Task Name")}
            rules={[
              {
                required: true,
              },
              {
                validator: (_, value) =>
                  value.trim() !== ""
                    ? Promise.resolve()
                    : Promise.reject(new Error("กรุณากรอกข้อมูล")),
              },
            ]}
          >
            <Input autoComplete="off" placeholder="Please Input Task Name" />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item name="listing" label="การแสดงในหน้า Task" initialValue="listed">
            <Select options={[{ value: 'listed', label: 'Listed — แสดงในรายการ' }, { value: 'unlisted', label: 'Unlisted — เข้าผ่านลิงก์' }]} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item name="access" label="สิทธิ์เข้าถึง" initialValue="public" help="Private: ต้องได้รับอนุมัติหรือใช้ลิงก์เชิญจากเจ้าของ">
            <Select options={[{ value: 'public', label: 'Public' }, { value: 'private', label: 'Private' }]} />
          </Form.Item>
        </Col>
        {/* Code Name */}
        <Col xs={24} md={12}>
          <Form.Item
            name="task_id"
            label={
              <div>
                {t("Task id")} :{" "}
                <span style={{ color: "#b3b3b3" }}>
                  ({t("This message does not contain spaces")})
                </span>
              </div>
            }
            rules={[
              {
                required: true,
                message: "Please enter Codename",
              },
              { validator: validateCodename },
            ]}
          >
            <Input
              autoComplete="off"
              disabled={props.params.action === "edit"}
              placeholder="Please Input Code Name"
              onKeyPress={(e) => {
                if (!/^[a-zA-Z0-9_-]$/.test(e.key)) {
                  e.preventDefault();
                }
              }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[16, 16]} align="middle">
        <Col xs={12}>
          <Form.Item
            name="submissiontype"
            label={t("Submission Type")}
            rules={[
              {
                required: false,
                message: "Please select a submission type!",
              },
            ]}
          >
            <Select
              placeholder="Please Select type"
              defaultValue={1}
              options={[
                {
                  value: 2,
                  label: "Result File Submission",
                },
                { value: 1, label: "Model Submission" },
              ]}
            />
          </Form.Item>
        </Col>
        <Form.Item
          noStyle
          shouldUpdate={(prev, cur) =>
            prev.submissiontype !== cur.submissiontype
          }
        >
          {({ getFieldValue }) =>
            getFieldValue("submissiontype") === 2 ? (
              <>
                <Col xs={9}>
                  <Form.Item
                    name="submission_file_name"
                    label={t("Submission File Name")}
                    rules={[
                      {
                        required: true,
                        message: "Please input submission file name!",
                      },
                    ]}
                  >
                    <Input placeholder="e.g. submission" />
                  </Form.Item>
                </Col>
                <Col xs={3}>
                  <Form.Item
                    name="submission_file_type"
                    label={t("File Type")}
                    rules={[
                      {
                        required: true,
                        message: "Please input file type!",
                      },
                    ]}
                  >
                    <Input placeholder="e.g. csv" />
                  </Form.Item>
                </Col>
              </>
            ) : null
          }
        </Form.Item>
      </Row>
      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <Form.Item name="tags" label={t("Tag")} rules={[{ required: false }]}>
            <Select
              mode="tags"
              value={tagSelect}
              style={{ width: "100%" }}
              tokenSeparators={[","]}
              maxTagCount="responsive"
              placeholder="Please select tags"
              optionFilterProp="label"
              options={tagOptions}
              onChange={handleChangeTag}
              onSelect={onSelectTag}
            ></Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="type"
            label={t("Task Type")}
            rules={[
              {
                required: false,
                message: "Input title of event please!",
              },
            ]}
          >
            <Select
              placeholder="Please select type"
              style={{ width: "100%" }}
              options={[
                { value: 2, label: "General" },
                { value: 1, label: "Event" },
              ]}
              maxTagCount="responsive"
            />
          </Form.Item>
        </Col>
      </Row>
      {/* =================team config */}
      <Row gutter={16}>
        <Col xs={12} md={6}>
          <Form.Item
            name="min_size"
            label={t("Team Member/min")}
            rules={[
              {
                required: false,
              },
            ]}
          >
            <InputNumber
              style={{ width: "100%" }}
              autoComplete="off"
              placeholder="Please Input Number Member"
              precision={0}
              min={1}
              defaultValue={1}
            />
          </Form.Item>
        </Col>
        <Col xs={12} md={6}>
          <Form.Item
            name="team_size"
            label={t("Team Member/max")}
            rules={[
              {
                required: false,
              },
            ]}
          >
            <InputNumber
              style={{ width: "100%" }}
              autoComplete="off"
              placeholder="Please Input Number Member"
              precision={0}
              min={1}
              defaultValue={1}
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="teamname_regex"
            label={t("Team Name Regex")}
            rules={[
              {
                required: false,
              },
              // {
              //   validator: (_, value) =>
              //     value.trim() !== ""
              //       ? Promise.resolve()
              //       : Promise.reject(new Error("กรุณากรอกข้อมูล")),
              // },
            ]}
          >
            <Input autoComplete="off" placeholder="Please Input Rule Regex" />
          </Form.Item>
        </Col>
      </Row>
      {/* ================ */}
      <Row>
        <Col xs={24}>
          <Form.Item
            name="information"
            label={t("Task Details")}
            rules={[
              {
                required: false,
                message: "input detail of information pls!!",
              },
            ]}
          >
            <Editor />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col xs={24}>
          <Form.Item
            name="datasetdetail"
            label={t("Dataset")}
            rules={[
              {
                required: false,
                message: "input detail of dataset pls!!",
              },
            ]}
          >
            <Editor />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col xs={24}>
          <Form.Item
            name="submission"
            label={t("Submission")}
            rules={[
              {
                required: false,
                message: "input detail of submission pls!!",
              },
            ]}
          >
            <Editor />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col xs={24}>
          <Form.Item
            name="evaluation"
            label={t("Evaluation")}
            rules={[
              {
                required: false,
                message: "input detail of evaluation pls!!",
              },
            ]}
          >
            <Editor />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col xs={24}>
          <Form.Item
            name="rules"
            label={t("Rules")}
            rules={[
              {
                required: false,
                message: "input detail of rule pls!!",
              },
            ]}
          >
            <Editor />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default InformationPage;
